import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Services.css';

const services = [
  { number: '01', title: 'Custom Software & Web Application Development', description: 'Bespoke software solutions tailored to your business needs.', features: ['Enterprise software', 'Web applications', 'API development', 'Legacy modernization'] },
  { number: '02', title: 'Website & Mobile Application Development', description: 'Responsive websites and native mobile apps.', features: ['Responsive design', 'iOS & Android', 'PWA', 'UX optimization'] },
  { number: '03', title: 'Cloud Services (AWS, Azure, GCP)', description: 'Cloud migration, optimization, and management.', features: ['Cloud migration', 'Multi-cloud', 'Cost optimization'] },
  { number: '04', title: 'DevOps, CI/CD & Infrastructure Automation', description: 'Automated pipelines and infrastructure as code.', features: ['CI/CD', 'IaC', 'Kubernetes', 'Monitoring'] },
  { number: '05', title: 'Application Support, IT Support & Managed Services', description: '24/7 support and managed IT services.', features: ['24/7 support', 'Monitoring', 'Help desk', 'Security'] },
];

const Services = () => (
  <>
    <Helmet>
      <title>Our Services - Helvion Solutions</title>
      <meta name="description" content="IT services: custom software, web and mobile apps, cloud, DevOps, managed IT support." />
    </Helmet>
    <main className="services-page">
      <section className="services-hero">
        <div className="services-hero-content">
          <h1>Our Services</h1>
          <p>Comprehensive IT solutions designed to transform your business operations and drive digital innovation.</p>
        </div>
      </section>
      <section className="section services-detail">
        {services.map((s, i) => (
          <div key={i} className="service-detail-card">
            <div className="service-detail-header">
              <div className="service-number">{s.number}</div>
              <h2>{s.title}</h2>
            </div>
            <p className="service-detail-description">{s.description}</p>
            <ul className="service-features-list">
              {s.features.map((f, j) => <li key={j}>{f}</li>)}
            </ul>
          </div>
        ))}
      </section>
      <section className="section services-cta-section">
        <div className="services-cta-content">
          <h2>Ready to Get Started?</h2>
          <p>Let's discuss how our services can help achieve your business goals.</p>
          <Link to="/contact" className="btn btn-primary">Contact Us</Link>
        </div>
      </section>
    </main>
  </>
);

export default Services;
